"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPos = void 0;
class GetPos {
    constructor(pointsOfSaleService) {
        this.pointsOfSaleService = pointsOfSaleService;
    }
    execute(request) {
        return this.pointsOfSaleService.getPos(request);
    }
}
exports.GetPos = GetPos;
